export const range = size => {
  const array = [];
  for (let i = 0; i < size; i++) {
    array.push(i);
  }
  return array;
};

export const arrayMoveElement = (arr, oldIndex, newIndex) => {
  if(oldIndex === -1)
    return arr;

  if (newIndex >= arr.length) {
    let k = newIndex - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
  return arr;
};
